import DOMPurify from "dompurify";

// Email layout tables must not pick up the application's data-table styling.
export function ticketEmailFragment(html) {
  const fragment = DOMPurify.sanitize(html || "", {
    RETURN_DOM_FRAGMENT: true,
    FORBID_TAGS: ["style", "link", "form", "input", "button", "iframe", "object", "embed"],
  });
  fragment.querySelectorAll("table").forEach((table) => {
    const rows = [...table.rows];
    const hasHeaders = rows.some((row) => [...row.cells].some((cell) => cell.tagName === "TH"));
    const singleColumn = rows.every((row) => row.cells.length <= 1);
    const layout = table.getAttribute("role") === "presentation" ||
      (!hasHeaders && (singleColumn || Boolean(table.querySelector("table"))));
    table.classList.add(layout ? "email-layout" : "email-data");
    if (layout) {
      // Remove inline !important dimensions too, so deeply nested wrappers can shrink.
      [table, ...table.querySelectorAll("tbody, thead, tfoot, tr, td, th")].forEach((element) => {
        if (element.closest("table") !== table && element !== table) return;
        ["width", "min-width", "max-width", "height", "min-height", "max-height"].forEach((property) => element.style.removeProperty(property));
        ["width", "height", "cellpadding", "cellspacing", "border"].forEach((attribute) => element.removeAttribute(attribute));
      });
    }
  });
  fragment.querySelectorAll("a[href]").forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
  return fragment;
}

export const ticketEmailStyles = `
:host { display: block; min-width: 0; max-width: 100%; }
.email-body { font: 14px/1.6 -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; color: #1e293b; overflow-wrap: anywhere; }
.email-body, .email-body * { box-sizing: border-box; }
.email-body * { max-width: 100% !important; }
p { margin: 0 0 .75rem; }
a { color: #2563eb; text-decoration: underline; overflow-wrap: anywhere; }
img { max-width: 100% !important; height: auto !important; object-fit: contain; }
blockquote { margin: .75rem 0; padding-left: .75rem; border-left: 2px solid #cbd5e1; }
ul, ol { padding-left: 1.5rem; }
pre { overflow-x: auto; white-space: pre-wrap; }
.email-layout { border: 0; border-spacing: 0; margin: 0; }
.email-layout > :is(tbody, thead, tfoot) > tr > :is(td, th) { border: 0; }
.email-data :is(td, th) { overflow-wrap: normal; word-break: normal; }
.email-data th { white-space: nowrap; }
.email-data { border-collapse: collapse; margin: .75rem 0; }
.email-data > :is(tbody, thead, tfoot) > tr > :is(td, th) { padding: .4rem .5rem; border: 1px solid #cbd5e1; text-align: left; }
@media (max-width: 767px) {
  .email-body * { min-width: 0 !important; overflow-wrap: anywhere; }
  .email-layout, .email-layout > :is(tbody, thead, tfoot), .email-layout > :is(tbody, thead, tfoot) > tr,
  .email-layout > :is(tbody, thead, tfoot) > tr > :is(td, th) {
    display: block !important; width: auto !important; height: auto !important; min-height: 0 !important;
    margin: 0 !important; padding: 0 !important; border: 0 !important;
  }
  .email-body > .email-layout { width: 100% !important; }
  .email-data { display: block; max-width: 100%; overflow-x: auto; }
}
:host([data-dark]) .email-body, :host([data-dark]) .email-body * {
  color: #e2e8f0 !important; background-color: transparent !important; background-image: none !important;
}
:host([data-dark]) .email-body a, :host([data-dark]) .email-body a * { color: #67e8f9 !important; }
:host([data-dark]) .email-body :is(td, th, blockquote, hr) { border-color: #475569 !important; }
`;
